const userAction = payload => {
  return {
    type: "LOGIN",
    payload
  };
};
export default userAction;
